/**
 * Header Class
 */
export  class  Header{

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl  ){

		this.headers = document.querySelectorAll( containerEl );
		if( !this.headers ){

			return false;

		}
		this.mobileMenuOpen( this.headers );
		this.menuToggle( '.menu-item-has-children' );
		this.scrollToggle( '.page-header', 'js-scroll' );

	}

	/**
	 * Mobile Menu Open
	 *
	 * @param {NodeList} headers
	 * @return {void}
	 */
	mobileMenuOpen( headers ){

		this.mobileMenuOpen = document.querySelector( '.js-mobile-button' );
		this.mobileMenuClose = document.querySelector( '.js-mobile-button-close' );

		headers.forEach( header => {

			this.mobileMenuOpen.addEventListener( 'click', ( e ) => {

				header.classList.toggle( 'js-open' );
				document.body.classList.toggle( 'freeze' );
				e.preventDefault();

			} );
			this.mobileMenuClose.addEventListener( 'click', ( e ) => {

				header.classList.remove( 'js-open' );
				document.body.classList.remove( 'freeze' );
				e.preventDefault();

			} );

		} );

	}

	/**
	 * Menu Toggle
	 *
	 * @param {string} hasChildSelector
	 * @return {void}
	 */
	menuToggle( hasChildSelector ) {

		const hasChild = document.querySelectorAll( hasChildSelector );

		hasChild.forEach( item => {

			const link = item.querySelector( ':scope > a' );

			link.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				/** close other menu */
				hasChild.forEach( otherItem => {

					if ( otherItem !== item && otherItem.classList.contains( 'js-open-menu' ) ) {

						otherItem.classList.remove( 'js-open-menu' );

					}

				} );

				/** toggle menu */
				item.classList.toggle( 'js-open-menu' );

			} );

		} );

		/** close menu when click outside */
		document.addEventListener( 'click', ( e ) => {

			if ( !e.target.closest( hasChildSelector ) ) {

				hasChild.forEach( item => {

					item.classList.remove( 'js-open-menu' );

				} );

			}

		} );

	}

	/**
	 * Scroll Toggle
	 *
	 * @param {string} headerSelector
	 * @param {string} className
	 * @return {void}
	 */
	scrollToggle( headerSelector, className ) {

		const header = document.querySelector( headerSelector );

		if ( window.scrollY > 0 ) {

			header.classList.add( className );

		} else {

			header.classList.remove( className );

		}

		window.addEventListener( 'scroll', () => {

			if ( window.scrollY > 0 ) {

				header.classList.add( className );

			} else {

				header.classList.remove( className );

			}

		} );

	}

}

